module.exports = __webpack_public_path__ + "static/media/radio_icon_checked.8acd65c4.png";